import React from 'react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { HeroSection } from '../components/HeroSection';
import { ValuePropsSection } from '../components/ValuePropsSection';
import { HowItWorksSection } from '../components/HowItWorksSection';
import { WhyChooseSection } from '../components/WhyChooseSection';
import { IdealClientsSection } from '../components/IdealClientsSection';
import { FAQSection } from '../components/FAQSection';
import { FinalCTASection } from '../components/FinalCTASection';
export function HomePage() {
  return <div className="w-full min-h-screen bg-white" data-id="element-206">
      <Navbar data-id="element-207" />
      <HeroSection data-id="element-208" />
      <ValuePropsSection data-id="element-209" />
      <HowItWorksSection data-id="element-210" />
      <WhyChooseSection data-id="element-211" />
      <IdealClientsSection data-id="element-212" />
      <FAQSection data-id="element-213" />
      <FinalCTASection data-id="element-214" />
      <Footer data-id="element-215" />
    </div>;
}